/* 
* 车辆档案之历史救援组件 
* 描述：对应车辆的历史救援
* 创建时间：2017-08-17
* 创建人：Shujuan Sun
* 修改时间：2017/09/20
* 修改人：DrugsZ
*/
<template>
	<div class="pl10px pr10px ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">服务状态</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="queryParam.serverStatus">
						<option v-for="option in serviceStatusArr" v-bind:value="option.value">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">请求开始时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.requestStartTime" class="form-control" ref="requestStartTime"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
				<label class="col-sm-1 control-label">请求结束时间</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': !validManageDates }">
					<datepicker v-model="queryParam.requestEndTime" class="form-control" ref="requestEndTime"></datepicker>
					<p v-if="!validManageDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">救援单号</label>
				<div class="col-sm-3">
						<input type="text" class="form-control" v-model="queryParam.orderId">
				</div>
				<label class="col-sm-1 control-label">救援类型</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="queryParam.rescueType">
						<option v-for="option in typeList" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">被救援车牌</label>
				<div class="col-sm-3">
					<input type="text" class="form-control"  v-model="queryParam.rescuedPlateNumber"/>
				</div>
		    <!--<label class="col-sm-1 control-label t_center">处理人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="queryParam.handleId">
				</div>-->
			</div>
		</div>
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">被救援人电话</label>
				<div class="col-sm-3">
					<input type="text" class="form-control"  v-model="queryParam.rescuedPhone"/>
				</div>
				<label class="col-sm-1 control-label">救援司机</label>
				<div class="col-sm-3">
					<input type="text" class="form-control"  v-model="queryParam.driverName"/>
				</div>
				<label class="col-sm-1 control-label">司机电话</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="queryParam.driverPhone"/>
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button v-if="permission.indexOf('carFileList_vehicleAlarmSelect') == -1" class="btn btn-primary" @click="searchInfo">查询</button>
					<button v-if="permission.indexOf('carFileList_vehicleAlarmReset') == -1" class="btn btn-primary" @click="resetQueryParams">重置</button>
				</div>
			</div>
		</div>
		<div class="hr-line-dashed"></div>
		<div class="location_table" style="overflow: hidden;">
				<div style="overflow: auto;">
					<table class="table mb0px table-striped table-bordered" style="min-width: 1600px;">
						<thead>
							<tr>
								<th rowspan="2">救援单号</th>
								<th rowspan="2">请求时间</th>
								<th rowspan="2">服务状态</th>
								<th rowspan="2">救援类型</th>
								<th rowspan="2">目的里程</th> 
								<th colspan="5" class="text-center">被救援信息</th>
								<th colspan="2" class="text-center">救援信息</th>
								<th rowspan="2"></th>
							</tr>
							<tr>
								<th>车牌号</th>
								<th>车型</th>
								<th>颜色</th>
								<th>电话</th> 
								<th>救援地址</th>
								<th>救援司机</th>
								<th>接单时间</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(fileInfo,index) in infoList" v-bind:key="index">
								<td>S{{fileInfo.orderId}}</td>
								<td>{{fileInfo.requestTimeNote}}</td>
								<td>{{fileInfo.rescueStageName}}</td>
								<td>{{fileInfo.rescueTypeName}}</td> 
								<td>{{fileInfo.descMileageNote}}km</td>
								<td>{{fileInfo.rescuedPlateNumber}}</td>
								<td>{{fileInfo.rescueModel}}</td>
								<td>{{fileInfo.rescueColor}}</td>
								<td>{{fileInfo.rescuedPhone}}</td>
								<td>{{fileInfo.rescueAddress}}</td>
								<td>{{fileInfo.driverName}}</td>
								<td>{{fileInfo.orderTimeNote}}</td>
								<td class="text-center"><a @click="detail(fileInfo.orderId)" v-if="fileInfo.rescueStage!=51&&fileInfo.rescueStage!=52&&fileInfo.rescueStage!=53">详情</a></td>
							</tr>
						</tbody>
					</table>
				</div>
		</div>
		<!--分页组件开始-->
		<pagination
			v-if="infoList.length>0"
			:pageInfo="pageInfo"
			v-on:getData="getPageNo"
			>						
		</pagination>
		<!--分页组件结束-->
	</div>
</template>
<script>
	import Datepicker from 'components/common/datepicker/Datepicker'
    import Pagination from 'components/common/Pagination'
    import {DICTIONARY_MAP} from 'static/constant'
    import { OPERATE_EXCEPTION } from 'static/message'
    import SubPage from 'components/common/SubPage'
    import classlist from 'util/classlist'
    
	export default {
		name: 'HistoryRescue',
		components: {
			Datepicker,
			Pagination,
			SubPage,
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				loadingstatus:false,
				infoList:[],							//从接口获取的表格数据
				pageInfo:{},							//传给分页组件的属性对象
				pageNo:1,								//从分页组件获取的当前页码数
				//以下为查询属性
				queryParam:{
					vehicleId:'',				//救援车辆id
					serverStatus:'',							//服务状态
					requestStartTime:'',				    //请求开始时间
					requestEndTime:'',						//请求结束时间
					rescueType:'',					//救援类型
					rescuedPlateNumber:'',						//被救援车牌
					rescuedPhone:'',					//被救援人电话
					driverName:'',					//救援司机
					driverPhone:'',					//救援司机电话
					orderId:'',						//救援单ID
					page_index:1
				},
				serviceStatusArr:[],						
				typeList:[],
				vehicleId:'',				//救援车辆id
			}
		},
		beforeMount(){
			//Object.assign(this.vehicleInfo, this.$parent.vehicleInfo);
			this.vehicleId = this.$parent.vehicleInfo.vehicleId;
			this.queryParam.vehicleId = this.vehicleId;
			this.getUdc();
			this.getTableInfo();
		},
		computed: {
			//	起止时间是否合法
			//	起止时间是否合法
			validManageDates: function(){
				if(this.queryParam.requestStartTime && this.queryParam.requestEndTime && this.queryParam.requestStartTime > this.queryParam.requestEndTime){
					return false;
				} else {
					return true;
				}
			}
		},
		methods:{
			//查询方法
			searchInfo(){
				this.queryParam.page_index = 1;
				this.getTableInfo();
			},
			//获取车辆报警信息
			getTableInfo() { 
				this.loadingstatus = true;
				//this.$http.get(process.env.API_ROOT +"/mockjs/41/rescue-api/vehicles/100/history?id=&requestStartTime=&driverPhone=&driverName=&serviceStatus=&type=&rescuedPlateNumber=&requestEndTime=&phone=&orderId=")
				this.$http.get(process.env.API_INSURANCE_ROOT+'/rescue-api/vehicles/'+this.vehicleId+'/history',{params:this.queryParam})
					.then((response) => {
						if(response.body.success) {
							const resInfo = response.body.data;								
							const {pageNum,pages,total,isFirstPage,isLastPage} = resInfo;
							this.pageInfo = {
								pageNum: pageNum,
								pages: pages,
								total: total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
							this.infoList = resInfo.list;
							this.infoList.map(item=>{
								if(item.requestTime)item.requestTime = item.requestTime.slice(2,16)
								if(item.orderTime)item.orderTime = item.orderTime.slice(2,16)
							})
						} else {
							this.$parent.openModal(response.body.message);
						}
						this.loadingstatus = false;
					}, (response) => {
						this.$parent.openModal(response.body.message);
						this.loadingstatus = false;
					})
					.catch((response) => {
						this.$parent.openModal(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
			//救援记录详情
			detail(id){
				const obj = {
					name:'RS'+id+'-车辆救援单详情',
					id:'HistoryDetail',
					route:'/indexhome/HistoryDetail' + id,
					No:'rescueCarDetail' + id,
						params:{id: id,vehicleId:this.vehicleId}
					}
					this.$router.push({path:'/indexhome/HistoryDetail' + id,query:obj.params});
					this.$store.dispatch('addTab',obj);
			},
			//报警详情
			openDetail(index){
				this.detailInfo = Object.assign({},this.infoList[index]);
				this.showSubPage = true
				this.bigTitle = "车辆报警详情"
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			closeSubPage(){
				this.showSubPage = false;
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			//报警处理
			openAlarmHandle(index){
				this.data = Object.assign({},this.infoList[index]);
				this.showAlarmSubPage = true
				this.bigTitle = "车辆报警处理"
				classlist.toggleScroll('close','#carfile-detail',this);
			},
			closeAlarmSubPage(){
				this.showAlarmSubPage = false;
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			savedAlarmSubPage(){
				this.getTableInfo();
				this.closeAlarmSubPage();
			},
			//从分页组件获取页码参数
			getPageNo(param) {
				this.queryParam.page_index = param;
				this.getTableInfo();
			},
			resetQueryParams:function(){
				this.$refs.requestStartTime.handleClear();
				this.$refs.requestEndTime.handleClear();
				this.queryParam = {
					orderId:'',			//救援单号
					serviceStatus:'',				//服务状态
					requestStartTime:'',		//开始时间
					requestEndTime:'',		//结束时间
					rescueType:'',				//救援类型
					rescuedPlateNumber:'',	//被救援人车牌号
					rescuedPhone:'',				//被救援人电话
					driverName:'',			//救援司机
					driverPhone:'',			//救援司机电话
					page_index:1
				}
			},
			setTypeStr(val){
				for(let k of this.typeList){
					if(k.udccode==val){
						return k.udcname
					}
				}
			},
			getUdc(){
//				let udcType = ['RESCUE_TYPE','STYLE']
//				let param = udcType.join(',');
				this.$http.get(process.env.API_ROOT  + '/system/udcs/license/2',{params:{udcTypes:'RESCUE_TYPE,STYLE' },headers:this.token})
				.then(res => {
					if(res.body.success){	
						let obj = res.body.data  
					 	for(let k of obj.RESCUE_TYPE){
					 		this.typeList.push(k)
					 	}
					 	for(let k of obj.STYLE){
					 		this.serviceStatusArr.push(k)
					 	}
					}else{
						this.openModalMsg(res.body.message);
					}
				}, res => {
					this.openModalMsg(res.body.message);
					if(res.body.message==''){
						this.openModalMsg('请求出问题啦');
					}
					
				}).catch( res => { 
					this.openModalMsg('请求异常');
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// HistoryRescue.vue?0f15bc2e